import { render, staticRenderFns } from "./emoji-picker-compact.vue?vue&type=template&id=48caffeb&scoped=true&"
import script from "./emoji-picker-compact.vue?vue&type=script&lang=js&"
export * from "./emoji-picker-compact.vue?vue&type=script&lang=js&"
import style0 from "./emoji-picker-compact.vue?vue&type=style&index=0&id=48caffeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48caffeb",
  null
  
)

export default component.exports